<template>
  <div
    v-for="item in items.splice(0, 3)"
    :key="item.id"
    class="mb-3 text-gray-500 text-sm"
  >
    <p>
      {{
        item.content.length > 100
          ? item.content.slice(0, 100) + "..."
          : item.content
      }}
    </p>
    <p>
      _{{ item.author }}
      <span class="float-right">{{ dateFormat(item.updated_at) }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Review",
  props: {
    data: Array
  },
  computed: {
    items() {
      return [...this.data];
    }
  }
};
</script>

<style></style>
